// import requestIdleCallback from 'requestIdleCallback';

export default async () => {
	return new Promise((resolve) => {
		requestAnimationFrame(resolve);
	});
};

export const idleCallback = async (wait = 1000) => {
	const idle = window.requestIdleCallback || requestAnimationFrame;

	return new Promise((resolve) => {
		idle(resolve, { timeout: wait });
	});
};
